import {RequestAuthorRoleArgs} from '~shared/schema/wiki/actions/access-request';

import {PageDetailsField} from '~shared/models';

import {i18n} from '~ui/components/PageSettingsDialog/i18n';

import toaster from '~ui/utils/toaster';
import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';
import {getPageDetailsById} from '~ui/services/pages';

export const requestAuthorRole = createThunk(
    'authors/request-role',
    async ({pageId}: RequestAuthorRoleArgs, {extra: {sdk}}) => {
        return sdk.wiki
            .requestAuthorRole({
                pageId,
            })
            .then((res) => {
                if (res.result === 'already_author') {
                    return null;
                }

                if (res.result === 'role_granted') {
                    toaster.createToast({
                        name: 'request-author-role',
                        type: 'success',
                        title: i18n('request-success-granted'),
                    });

                    return getPageDetailsById({
                        pageId,
                        fields: [PageDetailsField.Permissions, PageDetailsField.Authors],
                    });
                }

                if (res.result === 'already_sent') {
                    toaster.createToast({
                        name: 'request-author-role',
                        type: 'success',
                        title: i18n('request-success-sent'),
                    });

                    return null;
                }

                toaster.createToast({
                    name: 'request-author-role',
                    type: 'success',
                    title: i18n('request-success'),
                });

                return null;
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'request-author-role',
                    title: i18n('request-error'),
                }),
            );
    },
);
